module.exports = __webpack_public_path__ + "img/q-logo-white.fcc8543d.svg";